module.exports = __webpack_public_path__ + "img/principal-logo-header-es.77f3c42a.webp";